import { Component, ChangeDetectorRef } from '@angular/core';

import { UserService } from "../services/user.service"
import { MechanicsService } from "../services/mechanics.service"
// import { UtilsService } from "../services/utils.service"

@Component({
    selector: 'modal-login',
    templateUrl: './modal-login.component.html',
    styleUrls: ['./modal-login.component.styl'],
    standalone: false
})
export class ModalLoginComponent {

	hostname = window.location.hostname

	

	constructor(public ms: MechanicsService,
		public us: UserService,
		private cdr: ChangeDetectorRef) {

		// console.log(`modal login constructor - user = `, this.us.user)

		us.loginStep = "credentials";
		us.user.emailCode = "";

	}

	onInputChange($event, key) {
		// console.log(`Change triggered: value = `, $event.target.value);
		this.us.user[key] = $event.target.value.trim()
	}

	onSubmitLogin() {
		this.doLogin();
	}

	onNew($event) {
		// console.log(`New `, $event.target.value);
	}

	/*
	toggleDisableLogout() {
		this.ms.disableLogout = !this.ms.disableLogout
		localStorage.setItem("disableLogout", "" + this.ms.disableLogout)
	}
	*/

	get isLoginButtonDisabled(): boolean {
		return this.us.user.email.length < 5 || this.us.user.password.length < 2 || this.ms.isLoading
	}

	get isCheckCodeButtonDisabled(): boolean {
		return this.us.user.emailCode?.length < 5 || this.ms.isLoading
	}

	async doLogin() {
		await this.us.login();
		this.cdr.detectChanges();
	}
}
